export default __webpack_public_path__ + "static/pickup-great-wall-bbb9eba30424f54edddf58fbb5509d1a.png";